var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarquise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.008 68.764",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.514 26.077 19.514 33.885 23.315 32.37 27.564 20.931 19.514 26.077"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.583 26.08 10.509 21.026 14.807 32.369 18.583 33.892 18.583 26.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.54 48.585 18.583 43.082 18.583 35.246 14.799 36.78 10.54 48.585"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.387 35.942 17.773 34.569 14.4 33.209 7.705 34.584 14.387 35.942"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.105,5.1C9.026,13.391,3.466,23.816,3.418,34.514l.835-.172,9.562-1.964L8.921,19.463l-.263-.694.629.394,9.759,6.108,9.73-6.221.628-.4-.26.7L24.3,32.379l9.431,1.953,1.057.219C34.757,23.841,29.2,13.4,19.105,5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.282,36.784l4.866,13.464.263.728-.639-.436-9.718-6.632-.224.165-9.5,6.467-.638.434.262-.726,4.86-13.473L4.253,34.832l-.839-.17c0,10.745,5.57,21.222,15.691,29.54C29.227,55.881,34.8,45.4,34.8,34.653c0-.017,0-.034,0-.051l-1.058.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.514 43.099 19.803 43.312 27.558 48.588 23.295 36.792 19.514 35.286 19.514 43.099"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "23.704 35.952 30.329 34.578 23.722 33.21 20.272 34.586 23.704 35.952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.419,4.07H18.79C8.23,12.627,2.413,23.488,2.413,34.653S8.23,56.681,18.79,65.236h.629C29.98,56.68,35.8,45.819,35.8,34.653S29.98,12.628,19.419,4.07ZM34.8,34.653c0,10.748-5.568,21.228-15.69,29.549C8.984,55.884,3.416,45.407,3.414,34.662l.839.17,9.557,1.943L8.95,50.248l-.262.726.638-.434,9.5-6.467.224-.165,9.718,6.632.639.436-.263-.728L24.282,36.784l9.453-1.962,1.058-.22C34.793,34.619,34.8,34.636,34.8,34.653Zm-17.022-.084-3.386,1.373L7.705,34.584l6.7-1.375ZM10.509,21.026l8.074,5.054v7.812l-3.776-1.523Zm8.074,14.22v7.836l-8.043,5.5L14.8,36.78Zm4.732-2.876-3.8,1.515V26.077l8.05-5.146Zm.407.84,6.607,1.368L23.7,35.952l-3.432-1.366ZM23.3,36.792l4.263,11.8L19.8,43.312l-.289-.213V35.286Zm10.44-2.46L24.3,32.379l4.84-13.031.26-.7-.628.4-9.73,6.221L9.287,19.163l-.629-.394.263.694,4.894,12.915L4.253,34.342l-.835.172c.048-10.7,5.608-21.123,15.687-29.41C29.2,13.4,34.757,23.841,34.792,34.551Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarquise);
export default __webpack_public_path__ + "static/media/marquise.b620582f60a897cf453fcff89b957a84.svg";
export { ForwardRef as ReactComponent };